module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages"
  }, [_c('sub-ibox-title', [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("群发管理")])]), _vm._v(" "), _c('z-tab-bar', {
    attrs: {
      "list-obj": _vm.tabBarParams.list,
      "active": _vm.tabBarParams.active
    },
    on: {
      "handleClickTabBar": _vm.handleClickTabBar
    }
  }), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabBarParams.active != 'sendMassList'),
      expression: "tabBarParams.active != 'sendMassList'"
    }],
    staticClass: "content"
  }, [_c('z-radio-material', {
    attrs: {
      "radio-bar-params": _vm.radioBarParams,
      "is-layer-material": _vm.isLayerMaterial
    },
    on: {
      "cancelMaterialLayer": _vm.cancelMaterialLayer,
      "handleClickRadioBar": _vm.handleClickRadioBar,
      "handleSetContent": _vm.handleSetContent
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "p-t-10 tips"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabBarParams.active == 'kfSendMass'),
      expression: "tabBarParams.active=='kfSendMass'"
    }]
  }, [_vm._v("重要提示：客服消息群发，用户必须是和当前公众号48小时之内有互动才能到达，此接口群发微信有监管风险，慎重使用。")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabBarParams.active == 'wxSendMass'),
      expression: "tabBarParams.active=='wxSendMass'"
    }]
  }, [_vm._v("重要提示：群发接口群发，服务号每月限制4条，订阅号每天1条，超出则不能发送成功，请慎重使用。")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabBarParams.active == 'tpSendMass'),
      expression: "tabBarParams.active=='tpSendMass'"
    }]
  }, [_vm._v("重要提示：模板消息群发，发送条数无限制，任何时候都能达到，但是滥用有封号风险，请慎重使用。")])]), _vm._v(" "), _c('div', {
    staticClass: "m-t-20"
  }, [_c('a', {
    staticClass: "z-btn z-btn-primary b-r-3",
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("发送")])])], 1), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabBarParams.active == 'sendMassList'),
      expression: "tabBarParams.active=='sendMassList'"
    }]
  }, [_c('list', {
    ref: "list"
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-4b3fae65","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/mp/wechat/WxMass.vue
// module id = 840
// module chunks = 0